import script from "./GoBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoBackButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__